export default "__VITE_ASSET__CWt_zz_M__"